import React from "react";

const Gallery = () => <div>Gallery</div>;

export default Gallery;
